/**
 * The HTML a product description may hold — the API's allow-list (R0030 WP-05). The API sanitises what it stores;
 * the back office repeats the rule only to preview what is being typed, never to decide what is kept.
 */
export const PRODUCT_HTML_TAGS: ReadonlySet<string> = new Set([
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  'ul',
  'ol',
  'li',
  'a',
  'h2',
  'h3',
  'h4',
  'blockquote',
]);

/** Tags whose content is not text and is dropped with them. */
export const DROPPED_HTML_TAGS: ReadonlySet<string> = new Set([
  'script',
  'style',
  'textarea',
  'noscript',
  'iframe',
]);

/** A link's address when it is http, https or mailto; anything else — `javascript:`, `data:`, `//host` — none. */
export const safeHref = (href: string | null): string | null => {
  const trimmed = (href ?? '').trim();

  return /^(https?:\/\/|mailto:)/i.test(trimmed) ? trimmed : null;
};
